import AbstractFieldVisitor from "../metamodel/AbstractFieldVisitor";
import ArrayField from "../metamodel/Fields/ArrayField";
import EnumField from "../metamodel/Fields/EnumField";
import ImageField from "../metamodel/Fields/ImageField";
import LengthIntervalField from "../metamodel/Fields/LengthIntervalField";
import TextField from "../metamodel/Fields/TextField";
import BooleanField from "../metamodel/Fields/BooleanField";

export default class InputArgumentTypeFactory extends AbstractFieldVisitor<string> {
    private entityId: string;

    constructor(entityId: string) {
        super();
        this.entityId = entityId;

    }

    protected visitArrayField(field: ArrayField): string {
        return `${field.innerField.accept(this)}`;
    }

    protected visitEnumField(field: EnumField): string {
        return `[${this.entityId}${field.id}Enum]`;
    }

    protected visitImageField(field: ImageField): string {
        throw new Error("Not supported");
    }

    protected visitLengthIntervalField(field: LengthIntervalField): string {
        return `${this.entityId}${field.id}Interval`;
    }

    protected visitTextField(field: TextField): string {
        return "String";
    }

    protected visitBooleanField(field: BooleanField): string {
        return "Boolean";
    }

}


// WEBPACK FOOTER //
// ./src/factories/inputArgumentTypeFactory.tsx